import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { optimizeImageUrl } from "@faire/web--source/common/images/optimizeImages";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { Spacer } from "@faire/web--source/slate/spacing";
import { useState } from "@faire/web--source/ui/hooks/useState";
import { ResponsiveContentV2 } from "@faire/web--source/ui/ResponsiveContentV2";
import { trackR2BReferralsVisitsToLandingPageWithBonusReferralOfferView } from "@faire/web-api--source/events/r2BReferrals/view/visitsToLandingPageWithBonusReferralOffer";
import { observer } from "mobx-react";
import React, { useEffect } from "react";
import styled from "styled-components";
import { FooterSEOContent } from "@faire/retailer-visitor-shared/components/Footer/FooterSEOContent";
import { GeographicMap } from "@faire/retailer/components/GeographicMap";
import { useMarketStore } from "@faire/retailer-visitor-shared/stores/domain/Events/FaireMarkets/MarketStore";
import { BrandsLandingPageCaseStudies } from "../BrandsLandingPageCaseStudies";
import { BrandsLandingPageFaireMarketBanner } from "../BrandsLandingPageFaireMarketBanner";
import { BrandsLandingPageIntro } from "../BrandsLandingPageImprovementsIntro";
import { BrandsLandingPageTestimonials } from "../BrandsLandingPageTestimonials";
import { BrandsLandingPageTestimonialsSwipe } from "../BrandsLandingPageTestimonialsSwipe";
import { BRANDS_LANDING_PAGE_BELOW_HEADER_IMAGE, getIsShowingCaseStudies } from "../const";
import { getIntros } from "../intros";
import { CalendlySection } from "./CalendlySection";
import { Header } from "./Header";
import { TopSection } from "./TopSection";
var FAIRE_MARKET_SECTION = "faire-market-section";
var LandingPageBase = function() {
    var strictLocalize = useStrictLocalization().strictLocalize;
    var isSSR = useIsSSR();
    var _useState = _sliced_to_array(useState(false), 2), showCTA = _useState[0], setShowCTA = _useState[1];
    var showBrandLandingPage = useMarketStore([
        "showBrandLandingPage"
    ]).showBrandLandingPage;
    useEffect(function() {
        trackR2BReferralsVisitsToLandingPageWithBonusReferralOfferView();
    }, []);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            showBrandLandingPage && !showCTA ? /*#__PURE__*/ _jsx(BrandsLandingPageFaireMarketBanner, {
                faireMarketSectionId: FAIRE_MARKET_SECTION
            }) : null,
            /*#__PURE__*/ _jsx(Header, {
                showCTA: showCTA,
                setShowCTA: setShowCTA
            }),
            /*#__PURE__*/ _jsxs(Container, {
                children: [
                    /*#__PURE__*/ _jsx(TopSection, {}),
                    /*#__PURE__*/ _jsx(ResponsiveContentV2, {
                        mobile: /*#__PURE__*/ _jsx(MobileBannerImage, {
                            src: optimizeImageUrl({
                                url: BRANDS_LANDING_PAGE_BELOW_HEADER_IMAGE
                            }, isSSR)
                        })
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: {
                            mobileAndAbove: "3x",
                            desktopAndAbove: 96
                        }
                    }),
                    getIntros(isSSR, strictLocalize).map(function(intro) {
                        return /*#__PURE__*/ _jsxs("div", {
                            children: [
                                /*#__PURE__*/ _jsx(BrandsLandingPageIntro, {
                                    index: intro.index,
                                    header: intro.header,
                                    description: intro.description,
                                    richContent: intro.richContent,
                                    reverse: intro.reverse,
                                    startTracking: showCTA,
                                    eventKey: intro.eventKey
                                }),
                                /*#__PURE__*/ _jsx(Spacer, {
                                    height: {
                                        mobileAndAbove: "3x",
                                        tabletAndAbove: "6x"
                                    }
                                })
                            ]
                        }, intro.index);
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: {
                            mobileAndAbove: "1x",
                            tabletAndAbove: "4x",
                            desktopAndAbove: 96
                        }
                    }),
                    /*#__PURE__*/ _jsx(CalendlySection, {}),
                    getIsShowingCaseStudies() ? /*#__PURE__*/ _jsx(BrandsLandingPageCaseStudies, {}) : null,
                    /*#__PURE__*/ _jsx(ResponsiveContentV2, {
                        mobile: /*#__PURE__*/ _jsx(BrandsLandingPageTestimonialsSwipe, {})
                    }),
                    /*#__PURE__*/ _jsx(GeographicMap, {
                        showCaseStudies: getIsShowingCaseStudies()
                    }),
                    /*#__PURE__*/ _jsx(BrandsLandingPageTestimonials, {}),
                    /*#__PURE__*/ _jsx(FooterSEOContent, {})
                ]
            })
        ]
    });
};
export var LandingPage = observer(LandingPageBase);
var Container = styled.div.withConfig({
    componentId: "sc-b73359e4-0"
})([
    "width:100%;display:flex;flex-direction:column;margin:0 auto;align-items:center;position:relative;overflow-x:hidden;"
]);
var MobileBannerImage = styled.img.withConfig({
    componentId: "sc-b73359e4-1"
})([
    "height:112px;width:100%;object-fit:cover;object-position:center;"
]);
